import { ProjectStatusEnum } from 'api-hooks/projects/common';
import Tabs from 'components/common/tabs';
import useTranslation from 'next-translate/useTranslation';

interface Props {
  setActiveKey: (value: React.SetStateAction<React.Key>) => void;
  activeKey: React.Key;
  setStatus: (value: React.SetStateAction<string | undefined>) => void;
}

export default function ProjectListTabs(props: Props) {
  const { t } = useTranslation();
  const { activeKey, setActiveKey, setStatus } = props;

  return (
    <Tabs
      activeKey={activeKey}
      onChangeActive={({ activeKey }) => {
        setActiveKey(activeKey);
        if (activeKey === '0') {
          setStatus(`${ProjectStatusEnum.active}`);
        }
        if (activeKey === '1') {
          setStatus(
            `${ProjectStatusEnum.pending_cancel_approval}|${ProjectStatusEnum.cancel_draft}`,
          );
        }
        if (activeKey === '2') {
          setStatus(`${ProjectStatusEnum.canceled}`);
        }
        if (activeKey === '3') {
          setStatus(`${ProjectStatusEnum.completed}`);
        }
      }}
      items={[
        {
          title: t('common:processed'),
          component: <></>,
        },
        { title: t('common:need_approval'), component: <></> },
        { title: t('common:canceled'), component: <></> },
        { title: t('common:complete'), component: <></> },
      ]}
      overrideStyles={{
        tabList: { minHeight: '0px' },
        tab: { minHeight: '0px', height: '0', flexGrow: '0' },
        tabPanel: { minHeight: '0px', height: '0', flexGrow: '0' },
      }}
    />
  );
}
